<template>
  <!--  -->
  <div class="side-panel right com-right hf osy mr-30">
    <div class="side-panel-bg">
      <h1 class="f-20 pr-20 c-satwo">
        <span>环境监控 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
      </h1>
      <div class="data-bar comCenterTxt mt-10" style="vertical-align: bottom;">
        <div class="data-item">
          <span class="di-name">机房温度: </span>
          <span class="di-value" style="color: #35FFF6; font-family: aldrich,serif;">{{ envTH.temperature }}</span>&nbsp;
          <span class="di-unit">℃</span>
          <div class="data-item ml-20">
            <span class="di-name ">机房温度: </span>
            <span class="di-value" style="color: #35FFF6; font-family: aldrich,serif;">{{ envTH.humidity }}</span>&nbsp;
            <span class="di-unit">%</span>
          </div>
        </div>
      </div>
      <h3 class="f-12 pt-10 c-satwotitle mt-10">机柜空调出风温度</h3>
      <div class="fr ov bleftOne">
        <chart-line-temperature :chartData="outletTemperature" :colorIndex="0" style="width: 100%; height: 130px;" />
      </div>
      <h3 class="f-12 pt-10 c-satwotitle">机柜空调进风温度</h3>
      <div class="fr ov bleftOne">
        <chart-line-temperature :chartData="inletTemperature" :colorIndex="1" style="width: 100%; height: 130px;" />
      </div>

      <h1 class="f-20 c-satwo mt-10">
        <span>供电监控 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
      </h1>
      <div class="fr ov bleftOne mt-10">
        <pane-energy :chartData="energyMonitoring" style="width: 100%;" />
      </div>
      <div class="fr ov bleftOne mb-10">
        <pane-energy-usage :chartData="energyUsage" style="width: 100%;" />
      </div>
      <div class="fr ov bleftOne">
        <pane-energy-pueline :chartData="{ pueLine: this.pueLine, pueData: this.pueData }" style="width: 100%;" />
      </div>

    </div>
  </div>
</template>

<script>
import chartLineTemperature  from "@/views/sascreen/monitoring/chart-line-temperature.vue"
import paneEnergy from "@/views/sascreen/monitoring/pane-energy.vue"
import paneEnergyUsage from "@/views/sascreen/monitoring/pane-energy-usage.vue"
import paneEnergyPueline from "@/views/sascreen/monitoring/pane-energy-pueline.vue"

export default {
  name: 'com-right',
  components: {
    chartLineTemperature,
    paneEnergy,
    paneEnergyUsage,
    paneEnergyPueline,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      envTH: {},
      outletTemperature: {},
      inletTemperature: {},
      energyMonitoring: {},
      energyUsage: [],
      pueLine: {},
      pueData: {},
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(() => {
        this.envTH = this.resData.envTH
        this.outletTemperature = this.resData.outletTemperature
        this.inletTemperature = this.resData.inletTemperature
        this.energyMonitoring = this.resData.energyMonitoring
        this.energyUsage = this.resData.energyUsage
        this.pueLine = this.resData.pueLine
        this.pueData = this.resData.pueData
      }, 300)
    })
  },
  beforeDestroy() {
  },
  methods: {}
}
</script>

<style scoped>
/**********************************************************************************************************/


/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/
/**********************************************************************************************************/


.side-panel-bg{
  background: rgba(0,0,0,0) !important;
}
.monitorcont dl {
  width: 25%;
  float: left;
}

.monitorcont dl dt {
  margin-bottom: 2px;
}

.monitorcont dl dd:last-child {
  font-size: 10px;
  margin-bottom: 5px;
}

.centerNewsCon .centerNewsContitle {
  width: 90%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox {
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}

.centerNewsCon .blikunnewsicon {
  position: absolute;
  right: 7px;
  top: 23px;
}

.data-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.data-item {
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}

.di-name {
  color: #d4d8da;
  font-size: 14px;
  line-height: 14px;
  vertical-align: bottom;
  margin-right: 5px;
}

.di-value {
  font-size: 18px;
  line-height: 16px;
  font-weight: normal;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}

.di-unit {
  font-size: 10px;
  line-height: 10px;
  vertical-align: bottom;
}

.c-satwo{
  background: url(/imgs/complianceTitle.png) no-repeat;
  height: 40px;

}
.c-satwo span{
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 37px;
  line-height: 40px;
}


</style>
